<div class="cancel-redirect-button" *ngIf="showCancelRedirectButton()" (click)="handleClick($event)"></div>
